<template>
  <div>
    <VDialog
      :open="isOpenImportModal"
      :headline="name"
      modal
      full-width-body
      @close="resetUploadComponent"
      style="--dialog-min-inline-size: 700px; --dialog-max-inline-size: 900px; --dialog-max-block-size: 90vh;"
    >
      <template #body>
        <div class="import_customers">
          <div class="modal-footer">
            <div class="steps">
              <div class="step" :class="step === 1 ? 'selected' : ''">
                <div class="number">1</div>
                <div class="text">Upload</div>
              </div>
              <div class="divider"></div>
              <div class="step" :class="step === 2 ? 'selected' : ''">
                <div class="number">2</div>
                <div class="text">Label</div>
              </div>
              <div class="divider"></div>
              <div class="step" :class="step === 3 ? 'selected' : ''">
                <div class="number">3</div>
                <div class="text">Complete</div>
              </div>
            </div>
            <div class="modal-content-scrollable">
              <div v-if="step === 1">
                <div class="flex-center cust-brdr custPaddingBottom">
                  <div>
                    <h1 class="customer-info-title paddingBottom ion-text-center" style="margin: 0;">Upload file</h1>
                    <p v-if="type == 'customers'" class="sub-title" style="margin: 0;">Select the channel and upload your file.</p>
                  </div>
                </div>
                <div class="borderPadding">
                  <div v-if="type == 'customers'" class="info-box infoMessage">
                    <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
                    <p class="info-text">Customer import supports up to 100K records and accepts the following file formats: {{ acceptTypes }}</p>
                  </div>
                  <div v-else-if="type == 'broadcast'" class="info-box marginBottom cust-brdr">
                    <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
                    <p class="info-text">The file upload feature supports a maximum of 100K records and accepts the following formats: .csv, .xls, .xlsx, and .tsv</p>
                  </div>
                  <div v-if="step === 1">
                    <div>
                      <h3 class="title">Instructions & notes:</h3>
                      <ul class="custMargin padding-inline">
                        <li v-if="type !== 'dataRedact'"><a href="/jumper-sample-csv-tsv-xlsx.zip" download>Click here</a> to download the sample file and add the details of customers as per the sample file</li>
                        <li>These are the mandatory columns in the file:</li>
                        <table class="instructionsTable">
                          <thead>
                            <tr>
                              <th class="text-center">Column name</th>
                              <th class="text-center">Column description</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(property, description) in displayedInstructions" :key="property">
                              <td class="text-center">{{ description }}</td>
                              <td class="text-center">{{ property }}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div v-if="showInstructions">
                          <div v-if="type == 'dataRedact'">
                            <li>Download the customer list from the Customer section by clicking on "Customers" and then selecting "Export Customers"</li>
                            <li>Select the customers you wish to redact from the downloaded list and remove the others from the CSV file</li>
                          </div>
                          <div v-else>
                            <li>You can add columns for Basic Customer Attributes, such as First Name, Last Name, Email, Gender, and Date of Birth that are provided by default. For Date of Birth, please use the format DD/MM/YYYY.</li>
                            <li>You can add a column named "TAG" using which you can add custom tags to your customer (each tag needs to be separated by "@" sign, for eg.: tag1@tag2@tag3)</li>
                            <li>You can also add columns with any custom name in order to add "custom data" to your customer (for example we have added 2 columns in the sample file named "custom_field_1_name" and "custom_field_2_name"). You can add as many custom fields as you want.</li>
                            <!-- <li v-if="type == 'broadcast'">The maximum allowed custom tags per "Account" are 60, and custom data are 240. Check existing usage in the customers section and ensure you stay within these limits before uploading, or updates won't be applied.</li> -->
                            <!-- <li v-else>The maximum allowed custom tags per "Account" are 60, and custom data are 240. Check existing usage and ensure you stay within these limits before uploading, or updates won't be applied.</li> -->
                            <li>Finally, once you are ready with your customers file, you can click on the button below to upload a file.</li>
                            <li v-if="selectedChannel !== 'email'">You may also include a Marketing Opt-in Status column to indicate the customer's subscription preference, using the values Subscribed or Unsubscribed. If this column is not included, the Marketing Opt-in Status will be marked as No Status by default.</li>
                            <li v-if="type == 'customers'">After importing the customers, please wait for <b>30-45 minutes</b> and then simply reload the page to view your newly imported customers!</li>
                          </div>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="step === 2" class="borderPadding">
                <div class="flex-center cust-brdr custPaddingBottom">
                  <div>
                    <h1 class="customer-info-title paddingBottom ion-text-center" style="margin: 0;">Label fields</h1>
                    <p class="sub-title" style="margin: 0;">To ensure a smooth import, please label your fields.</p>
                  </div>
                </div>
                <div v-if="selectedFileName !== undefined" class="uploadedFileContainer flex-between">
                  <div class="flex-between">
                    <img src="../resources/images/dummy-uploaded_file.svg" alt="Uploaded file" />
                    <p class="title" style="margin: 0;">{{ selectedFileName }}</p>
                  </div>
                </div>
                <div class="flex-between optionsContainer cust-brdr">
                  <div v-if="showDelimeterAndEncoder" class="file_delimiter flex100P">
                    <p class="sub-title paddingBottom" style="margin: 0;">File Delimiter</p>
                    <VSelect v-model="file_delimiter" aria-label="File delimiter" placeholder="Select File Delimiter" appearance="ghost" class="vivid-select">
                      <VOption v-for="(delimiter, key) in filteredDelimiterItems" :key="key" :value="delimiter.text" :text="delimiter.value"></VOption>
                    </VSelect>
                  </div>
                  <div class="file_delimiter flex100P">
                    <p class="sub-title paddingBottom" style="margin: 0;">Skip rows</p>
                    <VSelect v-model="skipRowsModel" aria-label="Skip rows" placeholder="Select skip rows" appearance="ghost" class="vivid-select">
                      <VOption v-for="(rows, index) in skipRowsItems" :key="index" :value="String(rows)" :text="String(rows)"></VOption>
                    </VSelect>
                  </div>
                </div>
                <div v-if="showDuplicateColumn" class="flex-between optionsContainer cust-brdr">
                  <div class="flex-start gap10P">
                    <p class="sub-title flex100P" style="margin: 0;">What do you want to do with duplicate customers?</p>
                    <HelpTooltip floating :iconStyle="{'padding-top': '4px'}">
                      A duplicate is a record containing a mobile number, email or an external ID that already exist in the customers.
                    </HelpTooltip>
                  </div>
                  <VSelect v-model="handleDuplicatesModel" aria-label="Handle duplicates" placeholder="Select option" appearance="ghost" class="vivid-select flex100P">
                    <VOption value="false" text="Merge"></VOption>
                    <VOption value="true" text="Discard"></VOption>
                  </VSelect>
                </div>
                <div v-if="type == 'dataRedact' && tableData.length == 0" class="info-box infoMessage">
                  <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
                  <p class="info-text">Please ensure the csv contains ConversationID Header</p>
                </div>
                <div class="marginBottom">
                  <div v-if="tableData.length" class="label-table">
                    <div class="label-table-header">
                      <div class="col-name"><span class="sub-title">Column name</span></div>
                      <div class="col-value"><span class="sub-title">First value</span></div>
                      <div class="col-mapping"><span class="sub-title">Label field</span></div>
                    </div>
                    <div v-for="(item, index) in tableData" :key="index" class="label-table-row">
                      <div class="col-name"><span class="title">{{ item?.columnName }}</span></div>
                      <div class="col-value"><span class="title jumper-ellipsis" :title="item?.firstValue">{{ item?.firstValue }}</span></div>
                      <div v-if="tableData[index]" class="col-mapping">
                        <VSelect v-model="tableData[index].selectedMapping" @change="updateFileColumnHeaders(item?.columnName, tableData[index].selectedMapping)" aria-label="Assign field" placeholder="Assign Field" appearance="ghost" class="vivid-select">
                          <VOption v-for="(mappingItem, key) in getFieldMappingItems" :key="key" :value="mappingItem?.text" :text="mappingItem?.value"></VOption>
                        </VSelect>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="step === 3" class="importedContainer borderPadding">
                <div class="custPaddingBottom">
                  <div v-if="!showCloseModal" class="center-container">
                    <img src="../resources/images/importing_status.svg" class="importImg" alt="Importing status" />
                    <div>
                      <h2 class="header paddingBottom" style="margin: 0;">{{ type == 'broadcast' ? 'Uploading customers file' : 'Uploading customers'}}</h2>
                      <p class="sub-title" style="margin: 0;">This might take a few minutes... Please do not close this window.</p>
                    </div>
                  </div>
                  <div v-if="showCloseModal" class="center-container">
                    <img src="../resources/images/succesfullyUpload.svg" class="importImg" alt="Upload successful" />
                    <div>
                      <h2 class="header paddingBottom" style="margin: 0;">Upload complete</h2>
                      <p class="sub-title custPadding" style="margin: 0;">{{ type == 'broadcast' ? 'Customers file has been uploaded successfully.' : 'Customers has been uploaded successfully.'}}</p>
                      <p v-if="type == 'customers'" class="sub-title" style="margin: 0;">Please wait for <b>30-45 minutes</b> for all customers to be fully imported.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="footerBttn">
              <div v-if="step === 1">
                <div v-if="type == 'customers'" class="marginBottom">
                  <p class="title paddingBottom" style="margin: 0;">Channel</p>
                  <VSelect :disabled="loadingImport" v-model="importCsvChannel" aria-label="Channel" placeholder="Select channel" appearance="ghost" class="vivid-select">
                    <VOption v-for="(thisChannel, index) in availableImportChannels" :key="index" :value="thisChannel" :text="channels[thisChannel]?.name || thisChannel"></VOption>
                  </VSelect>
                </div>
                <div v-if="selectedFileName !== undefined" class="uploadedFileContainer flex-between">
                  <div class="flex-between">
                    <img src="../resources/images/dummy-uploaded_file.svg" class="fileImg" alt="Uploaded file" />
                    <p class="title" style="margin: 0;">{{ selectedFileName }}</p>
                  </div>
                  <VIcon name="delete-line" connotation="alert" class="trashIcon cursorPointer" @click="resetImport()" />
                </div>
                <div class="marginBottom">
                  <input type="file" style="display: none;" id="fileToImport" ref="fileToImport" @input="selectFileToImport($event)" :accept="acceptTypes" />
                  <VButton class="vvd-btn-secondary vvd-btn-block" connotation="cta" appearance="outlined" label="Upload file" icon="clear-file-line" @click="importCsv"></VButton>
                </div>
                <div class="flex-between">
                  <VButton class="vvd-btn-cancel flex100P" appearance="filled" label="Cancel" @click="closeModal"></VButton>
                  <VButton class="vvd-btn-primary flex100P" connotation="cta" appearance="filled" :label="!loadingImport ? 'Next' : ''" :disabled="loadingImport || (type == 'customers' && importCsvChannel == undefined) || selectedFileName == undefined" @click="nextStep">
                    <template v-if="loadingImport" #icon>
                      <VProgressRing class="vvd-spinner vvd-spinner-sm" connotation="cta" indeterminate />
                    </template>
                  </VButton>
                </div>
              </div>
              <div v-else-if="step === 2" class="flex-between">
                <VButton class="vvd-btn-cancel flex100P" appearance="filled" label="Back" @click="goBack"></VButton>
                <VButton class="vvd-btn-primary flex100P" connotation="cta" appearance="filled" :label="!spinnerLoader ? (type == 'customers' ? 'Import' : 'Upload') : ''" :disabled="spinnerLoader" @click="nextStep">
                  <template v-if="spinnerLoader" #icon>
                    <VProgressRing class="vvd-spinner vvd-spinner-sm" connotation="cta" indeterminate />
                  </template>
                </VButton>
              </div>
              <div v-else-if="step === 3">
                <div class="flex-between">
                  <VButton v-if="showCloseModal" class="vvd-btn-secondary flex100P" connotation="cta" appearance="outlined" label="Close" @click="closeModal"></VButton>
                  <VButton v-if="showCloseModal && type == 'customers'" class="vvd-btn-primary flex100P" connotation="cta" appearance="filled" label="Import status" @click="showImportStatus()"></VButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </VDialog>
  </div>

</template>

<script>

import Fuse from 'fuse.js';
import * as XLSX from 'xlsx';
import apiInterceptor from '@/shared/apiInterceptor';
import { channels } from "@/resources/js/bot-builder";
import HelpTooltip from "@/components/HelpTooltip.vue";
import { useUIStore } from '@/stores/ui';
import { useAuthStore } from '@/stores/auth';
import { useSocialChannels } from '@/composables/useSocialChannels';
import { environment } from '@/shared/env.js';

export default {
  emits: ["update:isOpenImportModal", "uploadedFilePath", "openImportStatusBttn"],
  components: { HelpTooltip },
  setup() {
    const { socialPlatformConnectedArray } = useSocialChannels();
    return { socialPlatformConnectedArray };
  },
  props: {
    isOpenImportModal: { type: Boolean, default: false },
    showInstructions: { type: Boolean, default: false },
    instructions: { type: Object, default: () => ({}) },
    acceptTypes: { type: String, default: '.csv' },
    showDuplicateColumn: { type: Boolean, default: false },
    type: { type: String, default: '' },
    name: { type: String, default: 'Import customers' },
    selectedChannel: { type: String, default: '' }
  },
  data() {
    return {
      loadingImport: false,
      importCsvChannel: undefined,
      selectedFileName: undefined,
      step: 1,
      selectedFile: undefined,
      showDelimeterAndEncoder: false,
      file_encoding: '',
      file_delimiter: '',
      skip_rows: 0,
      skipRowsItems: [0,1,2,3,4,5,6,7,8,9],
      delimiterItems: [
        { text: ',', value: ',(comma)' },
        { text: ';', value: ';(semicolon)' },
        { text: '#', value: '#(hash)' },
        { text: '~', value: '~(tilde)' },
        { text: '\t', value: 'tab' }
      ],
      handleDuplicates: false,
      tableData: [],
      channels,
      mappedColumns: {},
      spinnerLoader: false,
      showCloseModal: false,
      headers: [], // To store parsed CSV headers
      firstDataRow: [],  // To store first non-empty row of data
    };
  },
  computed: {
    user() { return useAuthStore().cleanUserData; },
    availableImportChannels() {
      return this.socialPlatformConnectedArray.filter(e => e === 'whatsapp' || e === 'googlercs' || e === 'sms' || e === 'email');
    },
    // Active channel for the current mode: dropdown for customers, selectedChannel for broadcast.
    activeImportChannel() {
      const channel = this.type === 'customers' ? this.importCsvChannel : this.selectedChannel;
      return String(channel ?? '').trim().toLowerCase();
    },
    // Mandatory-columns list shown in step 1. For the email channel only the
    // email column is required, so mobile number / country code are dropped.
    displayedInstructions() {
      if (this.type !== 'dataRedact' && this.activeImportChannel === 'email') {
        return { Email: "Recipient's Email address" };
      }
      return this.instructions;
    },
    getFieldMappingItems() {
      if (this.type === 'dataRedact') {
        return [{ text: 'ConversationID', value: 'ConversationID' }];
      }
      return [
        { text: 'firstName', value: 'First Name' },
        { text: 'lastName', value: 'Last Name' },
        { text: 'email', value: 'Email' },
        { text: 'mobileNumber', value: 'Mobile Number' },
        { text: 'gender', value: 'Gender' },
        { text: 'dob', value: 'Date of Birth' },
        { text: 'countrycode', value: 'Country Code' },
        { text: 'custom_field', value: 'Custom Field' },
        { text: 'TAG', value: 'Tags' },
        { text: 'marketing_opt_in_state', value: 'Marketing Opt-in Status' }
      ];
    },
    filteredDelimiterItems() { // filtering tab delimiter for dataRedact as we support only CSV
      if (this.type === 'dataRedact') {
        return this.delimiterItems.filter(item => item.value !== 'tab');
      }
      return this.delimiterItems;
    },
    // VSelect/VOption expect string values, but skip_rows is stored as a Number
    // (it's used as an array index). Proxy it as a string for the select.
    skipRowsModel: {
      get() { return String(this.skip_rows); },
      set(val) { this.skip_rows = Number(val); }
    },
    // VSelect/VOption expect string values, but handleDuplicates is stored as a
    // Boolean (sent as discard_duplicate_import). Proxy it as a string.
    handleDuplicatesModel: {
      get() { return String(this.handleDuplicates); },
      set(val) { this.handleDuplicates = val === 'true'; }
    }
  },
  watch: {
    skip_rows: {
      handler() {
        if (this.selectedFile && this.step === 2) {
          // Re-process the file when skip_rows changes
          this.reprocessFile();
        }
      }
    }
  },
  methods: {
    async handleUpload() {
      try {
        if (this.selectedFile && /\.(csv|xls|xlsx|tsv)$/i.test(this.selectedFile.name)) {
          const reader = new FileReader();
          reader.onload = async (event) => {
            let data;
            const fileExtension = this.selectedFile.name.split('.').pop().toLowerCase();
            if (fileExtension === 'csv' || fileExtension === 'tsv') {
              this.showDelimeterAndEncoder = true;
              // Handle CSV and TSV files
              let csv = event.target.result;
              if (typeof csv !== 'string') { csv = new TextDecoder().decode(csv); }  // For TSV or binary files (ArrayBuffer)
              csv = csv.replace(/\r/g, "");
              if (fileExtension === 'tsv') {
                this.file_delimiter = '\t';
              } else {
                const delimiters = [',', ';', '~', '#'];
                const delimiterCounts = delimiters.map(delimiter => ({
                  delimiter,
                  count: (csv.split("\n")[0].match(new RegExp(`\\${delimiter}`, "g")) || []).length
                }));
                delimiterCounts.sort((a, b) => b.count - a.count);
                this.file_delimiter = delimiterCounts[0]?.delimiter || ',';
              }
              const allLines = csv.split("\n");
              // AUTO-DETECT SKIP ROWS using all lines (including empty ones)
              const detectedSkipRows = this.detectSkipRows(allLines);
              this.skip_rows = detectedSkipRows;
              // Process headers and data based on skip_rows
              this.processCSVData(allLines);
            } else {
              // Handle Excel files
              this.showDelimeterAndEncoder = false;
              const arrayBuffer = event.target.result;
              const workbook = XLSX.read(arrayBuffer, { type: 'array' });
              const sheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[sheetName];
              data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
              this.headers = data[0];
              this.firstDataRow = data.slice(1).find(row => row.some(cell => cell !== "" && cell !== null && cell !== undefined)) || [];
            }
            this.validateAndMapHeaders();
          };
          if (this.selectedFile.name.toLowerCase().endsWith('.csv') || this.selectedFile.name.toLowerCase().endsWith('.tsv')) {
            reader.readAsText(this.selectedFile);
          } else {
            reader.readAsArrayBuffer(this.selectedFile);
          }
        }
      } catch (error) {
        console.error("Exception", error);
        useUIStore().updateToast({ open: true, message: "Something went wrong", type: "danger" });
      } finally {
        this.loadingImport = false;
      }
    },
    nextStep() {
      if (this.step === 1) {
        this.handleUpload();
        this.step++;
      } else if (this.step === 2) {
        if (this.validateMappedColumns(this.mappedColumns)) {
          this.step++;
          this.showCloseModal = false;
          this.uploadCsv();
        }
      }
    },
    processCSVData(lines) {
      // Skip the detected number of rows to get to headers
      const headerRowIndex = this.skip_rows;
      if (headerRowIndex >= lines.length) return;
      const headerLine = lines[headerRowIndex];
      if (!headerLine || headerLine.trim() === '') return;
      this.headers = headerLine.split(this.file_delimiter).map(header => header.trim());
      // Find first data row
      let firstDataRowIndex = headerRowIndex + 1;
      while (firstDataRowIndex < lines.length && (!lines[firstDataRowIndex] || lines[firstDataRowIndex].trim() === '')) {
        firstDataRowIndex++;
      }
      if (firstDataRowIndex < lines.length) {
        this.firstDataRow = lines[firstDataRowIndex].split(this.file_delimiter).map(cell => cell.trim());
      } else {
        this.firstDataRow = [];
      }
    },
    goBack() { this.step--; },
    validateMappedColumns(mappedColumns) {
      // For dataRedact type: only ConversationID is needed
      if (this.type === 'dataRedact') {
        const conversationIdExists = Object.values(mappedColumns).includes('ConversationID');
        if (!conversationIdExists) {
          useUIStore().updateToast({ open: true, message: "Please map 'Conversation ID' to proceed.", type: "danger", duration: 3000 });
          return false;
        }
        // Ensure the actual CSV has a valid 16-digit ID in first data row
        const conversationHeader = Object.keys(mappedColumns).find(key => mappedColumns[key] === 'ConversationID');
        if (conversationHeader && this.firstDataRow) {
          const conversationIndex = this.headers.indexOf(conversationHeader);
          const conversationValue = this.firstDataRow[conversationIndex];
          const digitsOnly = conversationValue?.toString().replace(/\D/g, '');
          if (!digitsOnly || digitsOnly.length < 16) {
            useUIStore().updateToast({ open: true, message: "Conversation ID must contain at least 16 digits.", type: "danger", duration: 3000 });
            return false;
          }
        }
        return true;
      }
      // For other types
      // Email channel requires an email column; other channels require mobile number + country code.
      const isEmailChannel = this.activeImportChannel === 'email';
      const mandatoryFields = isEmailChannel
        ? ["email"]
        : [
            "mobileNumber",
            "countrycode",
          ];
      const values = Object.values(mappedColumns);
      const missingFields = mandatoryFields.filter(field => !values.includes(field));
      if (missingFields.length > 0) {
        const missingFieldNames = missingFields.map(field => {
          switch(field) {
            case "mobileNumber": return "mobile number";
            case "countrycode": return "country code";
            case "email": return "email";
            default: return field;
          }
        });
        useUIStore().updateToast({ open: true, message: `Please map the following label to import: ${missingFieldNames.join(', ')}`, type: "danger", duration: 3000 });
        return false;
      }
      return true;
    },
    importCsv() {
      if (!this.importCsvChannel && this.type == 'customers') return useUIStore().updateToast({ open: true, message: "Please select a channel first!", type: "danger" });
      this.$refs.fileToImport.click();
    },
    resetImport() { this.selectedFile = undefined; this.selectedFileName = undefined; },
    selectFileToImport(event) { this.selectedFileName = event.target.files[0].name; this.selectedFile = event.target.files[0]; },
    async uploadCsv() {
      try {
        if (this.type == 'dataRedact') {
          var uploadedFileObject = { fileName: this.selectedFileName, filePath: this.selectedFile, file_delimiter: this.file_delimiter, skip_rows: this.skip_rows, column_mapping: JSON.stringify(this.mappedColumns) };
          this.showImportStatus();
          this.$emit('uploadedFilePath', uploadedFileObject);
        } else {
          var reqBody = new FormData();
          reqBody.append('file_object', this.selectedFile);
          if (this.type == 'broadcast') { reqBody.append('channel', this.selectedChannel.toLowerCase()); }
          else if (this.type == 'customers') { reqBody.append('channel', this.importCsvChannel.replace(/\s+/g, '').toLowerCase()); }
          if (this.showDelimeterAndEncoder) { reqBody.append('file_delimiter', this.file_delimiter); reqBody.append('file_encoding', ''); }
          reqBody.append('skip_rows', this.skip_rows);
          reqBody.append('column_mapping', JSON.stringify(this.mappedColumns));
          if (this.type == 'customers') { reqBody.append('discard_duplicate_import', this.handleDuplicates); }
          if (this.type == 'broadcast') { reqBody.append('shopname', this.user.referallshopName); }
          this.spinnerLoader = true;
          this.showCloseModal = false;
          const url = this.type == 'customers' ? 'crm/v1/customers/import' : 'broadcast-executor/upload';
          const uploadCsvResponse = await apiInterceptor.post(environment('VUE_APP_API_URL') + url, reqBody, { headers: { "Content-Type": "multipart/form-data" } });
          if (this.type == 'broadcast') {
            var uploadedFileObject = { fileName: this.selectedFileName, filePath: uploadCsvResponse.filepath, targetingCount: uploadCsvResponse.rowcount };
            useUIStore().updateToast({ open: true, message: "Successfully validated and uploaded file", type: "success" });
            this.$emit('uploadedFilePath', uploadedFileObject);
          }
          this.showCloseModal = true;
          this.resetImport();
        }
      } catch (error) {
        this.resetUploadComponent();
        useUIStore().updateToast({ open: true, message: error.message, type: "danger", duration: 5000 });
      } finally {
        this.spinnerLoader = false;
      }
    },
    updateFileColumnHeaders(columnName, selectedMapping) { this.mappedColumns[columnName] = selectedMapping; },
    closeModal() { this.resetImport(); this.$emit('update:isOpenImportModal', false); },
    resetUploadComponent() { this.resetImport(); this.step = 1; this.mappedColumns = {}; this.tableData = []; this.showCloseModal = false; this.importCsvChannel = undefined; this.headers = []; this.firstDataRow = []; this.$emit('update:isOpenImportModal', false); },
    showImportStatus() { this.resetUploadComponent(); this.$emit('openImportStatusBttn'); },
    detectSkipRowsForDataRedact(lines) { // skiprows for dataRedact
      for (let i = 0; i < Math.min(10, lines.length); i++) {
        const currentLine = lines[i];
        if (!currentLine || currentLine.trim() === '') continue;
        const cells = currentLine.split(this.file_delimiter).map(cell => cell.trim());
        // Skip if too few cells or mostly empty
        if (cells.length < 2) continue;
        const nonEmptyCells = cells.filter(cell => cell && cell !== '');
        if (nonEmptyCells.length < cells.length * 0.5) continue;
        // For dataRedact, specifically look for ConversationID
        const hasConversationID = cells.some(cell => { const cellLower = cell.toLowerCase(); return cellLower === 'conversationid' || cellLower.includes('conversationid') || (cellLower.includes('conversation') && cellLower.includes('id')); });
        // Also check if it looks like a data row (should reject it)
        const looksLikeData = cells.some(cell =>
          /^\d{10,}$/.test(cell) ||  // Long numbers (IDs)
          /@/.test(cell) ||          // Emails
          /^\d{4}-\d{2}-\d{2}/.test(cell) // Dates
        );
        if (hasConversationID && !looksLikeData) return i; // Header found at i
      }
      return 0; // No Header Found
    },
    detectSkipRows(lines) { return this.type === 'dataRedact' ? this.detectSkipRowsForDataRedact(lines) : this.detectSkipRowsOriginal(lines); },
    detectSkipRowsOriginal(lines) {
      const maxRowsToCheck = Math.min(10, lines.length); // Check first 10 rows max
      for (let i = 0; i < maxRowsToCheck; i++) {
        const currentLine = lines[i];
        // Skip completely empty lines
        if (!currentLine || currentLine.trim() === '') continue;
        const cells = currentLine.split(this.file_delimiter).map(cell => cell.trim());
        // Skip if row has too few cells (likely not headers)
        if (cells.length < 2) continue;
        // Skip if most cells are empty
        const nonEmptyCells = cells.filter(cell => cell && cell !== '');
        if (nonEmptyCells.length < cells.length * 0.5) continue;
        // Check header score by comparing with known field mappings
        const headerScore = this.calculateHeaderScore(cells);
        // Dynamic threshold based on type and number of expected fields
        const dynamicThreshold = this.type === 'dataRedact' ? Math.min(0.3, 1 / cells.length + 0.05) : 0.3;
        if (headerScore >= dynamicThreshold) return i; // Return the row index where headers are found
      }
      return 0; // Default to no skip if can't detect
    },
    calculateHeaderScore(cells) {
      // Get all known field names from our field mapping (firstName, lastName, etc.)
      const knownFields = this.getFieldMappingItems.map(item => item.text.toLowerCase());
      let matches = 0;
      // Check each cell in the potential header row
      cells.forEach(cell => {
        const cellLower = cell.toLowerCase();
        // Check if this cell matches any of our known field names
        const hasMatch = knownFields.some(field => {
          if (this.type === 'dataRedact') {
            // For dataRedact, we want stricter matching since we only have one required field
            // Only exact matches or very close variants
            return cellLower === field || cellLower.includes(field) || field.includes(cellLower) || this.fuzzyMatchStrings(cellLower, field) === 0; // Exact match only
          }
          // 1. Does the cell contain the field name?
          // Example: "mobileNumber" contains "mobilenumber"
          // 2. Does the field name contain the cell value?
          // Example: "mobilenumber" contains "mobile"
          // 3. Are they similar with small typos? (max 2 character differences)
          // Example: "firstname" vs "firstName" (distance = 1)
          // Example: "email" vs "emial" (distance = 2)
          return cellLower.includes(field) || field.includes(cellLower) || this.fuzzyMatchStrings(cellLower, field) <= 2;
        });
        // If we found a match using any of the three methods above, count it
        if (hasMatch) matches++;
      });
      // Return the percentage of cells that matched known fields
      // Score of 1.0 = 100% of cells are recognized headers
      // Score of 0.5 = 50% of cells are recognized headers
      // Score of 0.0 = 0% of cells are recognized headers
      return matches / cells.length;
    },
    // Using Levenshtein Distance: Calculates the minimum number of single-character edits
    // (insertions, deletions, or substitutions) needed to transform one string into another
    fuzzyMatchStrings(str1, str2) {
      const matrix = [];
      // Initialize first column: distance from empty string to each prefix of str2
      for (let i = 0; i <= str2.length; i++) { matrix[i] = [i]; }
      // Initialize first row: distance from empty string to each prefix of str1
      for (let j = 0; j <= str1.length; j++) { matrix[0][j] = j; }
      // Fill the matrix by comparing each character
      for (let i = 1; i <= str2.length; i++) {
        for (let j = 1; j <= str1.length; j++) {
          // If characters match, no additional cost - take diagonal value
          if (str2.charAt(i - 1) === str1.charAt(j - 1)) { matrix[i][j] = matrix[i - 1][j - 1]; }
          else {
            // Characters don't match - find minimum cost operation:
            matrix[i][j] = Math.min(
              matrix[i - 1][j - 1] + 1, // Substitution: replace character
              matrix[i][j - 1] + 1,     // Insertion: add character to str1
              matrix[i - 1][j] + 1      // Deletion: remove character from str2
            );
          }
        }
      }
      return matrix[str2.length][str1.length];
    },
    async reprocessFile() {
      if (!this.selectedFile) return;
      const reader = new FileReader();
      reader.onload = (event) => {
        let csv = event.target.result;
        if (typeof csv !== 'string') { csv = new TextDecoder().decode(csv); }
        csv = csv.replace(/\r/g, "");
        const lines = csv.split("\n").filter(line => line.trim() !== '');
        this.processCSVData(lines);
        this.validateAndMapHeaders();
      };
      reader.readAsText(this.selectedFile);
    },
    validateAndMapHeaders() {
      if (this.headers.length > 100000) { return useUIStore().updateToast({ open: true, message: "The file should not exceed 100,000 customers", type: "danger" }); }
      if (!this.headers || !this.headers.length) { return useUIStore().updateToast({ open: true, message: "The required headers are missing", type: "danger" }); }
      this.loadingImport = true;
      // Configure Fuse for header mapping

      const fuseOptions = { includeScore: true, threshold: 0.4, keys: ['text', 'value'] };
      const fuse = new Fuse(this.getFieldMappingItems, fuseOptions);
      // Columns that must always be mapped to "custom_field" regardless of fuzzy matching.
      const forcedCustomFieldHeaders = new Set(['from_email', 'from_display_name']);
      // Known date-of-birth aliases that should always map to the "dob" field.
      const dobHeaderAliases = new Set(['dob', 'date of birth', 'date_of_birth', 'dateofbirth', 'birth date', 'birthdate', 'birthday']);
      this.tableData = this.headers.map((header, index) => {
        if (this.type === 'dataRedact' && header !== 'ConversationID') return null;
        let selectedMapping = '';
        const normalizedHeader = String(header ?? '').trim().toLowerCase();
        if (this.type !== 'dataRedact' && forcedCustomFieldHeaders.has(normalizedHeader)) {
          selectedMapping = 'custom_field';
        } else if (this.type !== 'dataRedact' && dobHeaderAliases.has(normalizedHeader)) {
          selectedMapping = 'dob';
        } else {
          const searchResult = fuse.search(header);
          if (searchResult.length > 0 && searchResult[0].score <= 0.4) { selectedMapping = searchResult[0].item.text; }
        }
        return { columnName: header, firstValue: this.firstDataRow[index] || '', selectedMapping };
      });
      this.tableData = this.tableData.filter(item => item !== null);
      this.mappedColumns = {};
      this.tableData.forEach(item => { if (item.selectedMapping) { this.mappedColumns[item.columnName] = item.selectedMapping; } });
      this.loadingImport = false;
    }
  }
}
</script>


<style lang="scss" scoped>
.steps {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  padding: 20px;
  .step {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    font-size: 0.8rem;
    .text {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: var(--gray-04);
    }
    &.selected {
      .number {
        background-color: var(--purple);
        color: var(--white);
      }
      .text {
        color: var(--purple);
      }
    }
    .number {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      background-color: var(--background-primary);
    }
  }
  .divider {
    border-bottom: 1px solid var(--background-primary);
    width: 45px;
  }
}
</style>

<style scoped>
.custPadding {
  padding-bottom: 5px;
}
.instructionsTable {
  margin: 10px 0px 20px 0px;
}
.instructionsTable thead {
  background: var(--purple-opac);
  color: var(--black);
}
.instructionsTable th, td {
  font-size: 14px;
  color: var(--black);
  font-weight: 400;
  text-transform: none;
}
.instructionsTable td, th {
  border: 1px solid var(--gray-04);
  text-align: left !important;
}
.custPaddingBottom {
  padding-bottom: 20px;
}
.uploadedFileContainer {
  background: var(--background-primary);
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 20px;
}
.header {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  color: var(--black);
}
.infoMessage {
  margin: 20px 0px;
}
.info-box {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  background: var(--purple-opac);
  padding: 15px;
  border-radius: 5px;
  font-size: 14px;
}
.info-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--black);
  margin: 0;
}
.infoIcon {
  margin-right: 5px;
}
table {
  border-width: 0px;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  background: none;
}
.center-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 47vh;
  text-align: center;
}
.importImg {
  max-width: 100%;
  height: auto;
  margin-bottom: 20px;
}
.import_customers {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 80vh;
}
.modal-footer {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.steps {
  flex-shrink: 0;
}
.modal-content-scrollable {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  padding: 0 20px;
}
.footerBttn {
  flex-shrink: 0;
  padding: 20px;
  border-top: 1px solid var(--background-primary);
}
.borderPadding {
  padding: 0;
}
.importedContainer {
  border-top: 1px solid var(--background-primary);
  padding-top: 20px;
}
.fileImg {
  width: 40px;
  height: 40px;
}

/* Label table grid */
.label-table {
  border-top: 1px solid var(--background-primary);
  margin-top: 10px;
}
.label-table-header,
.label-table-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid var(--background-primary);
}
.col-name, .col-value, .col-mapping {
  min-width: 0;
}
.jumper-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.padding-inline{ 
  padding-inline-start: 20px;
}
ion-content ul li {
  padding-bottom: 15px;
}
</style>
